/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";

import Modal from "../components/Modal";

import { useModalStore } from "../stores/hooks";

import {
  COMPLETED_LOCATIONS,
  COMPLETED_LOCATION_POSTBOX,
} from "../utils/delivery";

const LocationItem = ({ active, location, onSelect }) => {
  const handleSelect = () => {
    let body = {
      code: location.code,
      text: location.text,
    };

    onSelect(body);
  };

  return (
    <div>
      <label className="block mb-10" onClick={handleSelect}>
        <input
          type="radio"
          name="corp"
          defaultChecked={!!active}
          className="mr-5"
        />
        {location.text}
      </label>
    </div>
  );
};

function UpdateCompletedLocationModal({
  cancelable = false,
  captureMethod,
  bookIds,
  location, // 완료 위치 정보
  imageUrl, // 완료이미지 경로
  onSubmit,
}) {
  const { closeModal } = useModalStore();

  const { register, handleSubmit, reset, setValue, watch } = useForm();

  const [load, setLoad] = useState(false);

  useEffect(() => {
    reset({
      code: COMPLETED_LOCATIONS[0].code,
      text: COMPLETED_LOCATIONS[0].text,
    });

    setLoad(true);
  }, []);

  const handleSelectLocation = ({ code, text }) => {
    setValue("code", code);
    setValue("text", text);
    setValue("postboxPassword", "");
  };

  const handleDeletePostboxPassword = () => {
    setValue("postboxPassword", "");
  };

  const handleCancel = () => {
    closeModal();
  };

  const onSubmitModal = (data) => {
    const completedLocation = `${data.text}${
      data.code === COMPLETED_LOCATION_POSTBOX && data.postboxPassword
        ? `(${data.postboxPassword})`
        : ""
    }`;

    onSubmit({
      ...data,
      captureMethod,
      bookIds,
      location,
      imageUrl,
      completedLocation,
      completedLocationCode: data.code,
    });
  };

  return (
    <Modal>
      <div className="p-15">
        <form onSubmit={handleSubmit(onSubmitModal)}>
          <div className="mb-20">
            <h5 className="font-medium text-18 mb-10">배송 위치 선택</h5>
            <div>
              {load &&
                COMPLETED_LOCATIONS.map((location) => {
                  let active = location.code === watch("code");

                  return (
                    <div key={location.code}>
                      <LocationItem
                        active={active}
                        location={location}
                        onSelect={handleSelectLocation}
                      />
                      {location.code === COMPLETED_LOCATION_POSTBOX && (
                        <div className="ml-10 mb-10">
                          <div className="bg-[#f6f6f6] p-5 flex justify-between items-center">
                            <input
                              type="text"
                              className="bg-transparent max-w-[calc(100vw-120px)] flex-1"
                              disabled={!active}
                              maxLength={10}
                              {...register("postboxPassword")}
                              placeholder="택배함 비밀번호"
                            />
                            <button
                              type="button"
                              className="text-[#999] p-5 w-50"
                              onClick={handleDeletePostboxPassword}
                            >
                              삭제
                            </button>
                          </div>
                          <div className="text-11 text-gray-a mt-5">
                            특수문자 &#123;, &#125;, &#34;는 사용할 수 없습니다.
                          </div>
                        </div>
                      )}
                    </div>
                  );
                })}
              <input name="code" {...register("code")} hidden />
              <input name="text" {...register("text")} hidden />
            </div>
          </div>
          <div className="flex justify-center items-center">
            {cancelable && (
              <button
                type="button"
                className="flex-1 p-10"
                onClick={handleCancel}
              >
                닫기
              </button>
            )}

            <button type="submit" className="text-orange flex-1 p-10">
              확인
            </button>
          </div>
        </form>
      </div>
    </Modal>
  );
}

export default UpdateCompletedLocationModal;
